import { Component } from "@angular/core";

import { SvgMixinLargeComponent } from "../svg-large-mixin.component";

@Component({
  selector: "med-icon-aimbulance",
  templateUrl: "./med-icon-aimbulance.component.html",
})
export class MedIconAimbulanceComponent extends SvgMixinLargeComponent { }
